<template>
    <div>
        <div class="pb-1">
            <div class="flex-grow-1 of-y px-2 pb-1">
                <v-text-field
                        label="Recruitment Group Name"
                        v-model="editGroup.description"
                        :rules="[validationRules.required, validationRules.notNull]"
                        class="mt-2"
                        ref="groupName"
                />

                <v-menu open-on-hover bottom offset-y nudge-top="5" :close-on-content-click="false" max-width="300">
                    <template v-slot:activator="{on}">
                        <v-text-field

                                label="Cut Off Date"
                                readonly
                                color="primary"
                                hide-details
                                v-model="cutOffDateModel"
                                v-on="on"
                                class="mb-4"
                        />
                    </template>
                    <v-date-picker
                            full-width
                            class="flex-grow-0"
                            v-model="cutOffDateModel"
                            no-title
                            :elevation="1"
                    >
                    </v-date-picker>
                </v-menu>
              
              <v-switch
                  v-model="archived"
                  hide-details="true"
                  label="Archived"
                  class="mt-2 mb-4"
              ></v-switch>
            </div>

            <divider/>

            <div class="text-right pr-2 pb-1 pt-2">
                <v-btn
                        @click="resetEditGroup"
                        color="primary"
                        :disabled="loading"
                        small
                        outlined
                        class="mr-2"
                >
                    Reset
                </v-btn>

                <v-btn
                        @click="validateSave()"
                        color="primary"
                        :loading="loading"
                        :disabled="loading"
                        small
                >
                    Save Changes
                </v-btn>
            </div>

        </div>
    </div>
</template>

<script>
import {validationRules} from "../../core/codeFunctions";
import {format, parse} from "date-fns";
import Divider from "../General/Divider";

export default {
    components: {Divider},

    props: {
        group: Object
    },
    data() {
        return {
            validationRules,
            editGroup: {
                description: null,
                cutOff: new Date(),
              archived: 0
            },
            loading: false
        }
    },
    watch: {
        group: {
            immediate: true,
            handler(val) {
                this.resetEditGroup()
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.groupName.focus()
        }, 500)
    },
    methods: {
        async validateSave() {

            if (!this.editGroup.description || !this.editGroup.cutOff)
                return this.$snack.error('Complete All Fields')

            try {
                this.loading = true
                const savedObj = await this.$newReq('POST', `recruitment/groups`, this.editGroup)
              this.group.archived = savedObj.archived
                this.$emit('input', savedObj)
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.loading = false;
            }



        },
        resetEditGroup() {
            this.editGroup = {
                id: null,
                description: null,
                cutOff: new Date(),
                ...JSON.parse(JSON.stringify(this.group || {}))
            }

            if (!this.editGroup.cutOff)
                this.editGroup.cutOff = new Date()

            if (typeof this.editGroup.cutOff === 'string')
                this.editGroup.cutOff = new Date(this.editGroup.cutOff)

            if (typeof this.editGroup.created === 'string')
                this.editGroup.created = new Date(this.editGroup.created)
        }
    },
    computed: {
      
      archived: {
        get() {
          return !!this.editGroup.archived
        },
        set(val) {
          return this.editGroup.archived = val ? 1 : 0
        }
      },
      
        cutOffDateModel: {
            get() {
                try {
                    return format(this.editGroup.cutOff, 'yyyy-MM-dd')
                } catch (e) {
                    return "Invalid Date"
                }
            },
            set(val) {
                this.editGroup.cutOff = parse(val, 'yyyy-MM-dd', new Date());
            }
        },
    }
}
</script>

<style scoped>

</style>